/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Ship_Title4Inputs */

const en_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployment and handoff`)
};

const ar_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشر والتسليم`)
};

const bn_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপ্লয় ও হস্তান্তর`)
};

const de_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployment und Übergabe`)
};

const es_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despliegue y entrega`)
};

const fr_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déploiement et passation`)
};

const pt_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançamento e entrega`)
};

const zh_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部署与交接`)
};

const tr_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayın ve devir`)
};

const ru_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Деплой и передача`)
};

const pl_svc_ai_app_rescue_ship_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożenie i przekazanie`)
};

/**
* | output |
* | --- |
* | "Deployment and handoff" |
*
* @param {Svc_Ai_App_Rescue_Ship_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_ship_title4 = /** @type {((inputs?: Svc_Ai_App_Rescue_Ship_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Ship_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_ship_title4(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_ship_title4(inputs)
	return en_svc_ai_app_rescue_ship_title4(inputs)
});
export { svc_ai_app_rescue_ship_title4 as "svc_ai-app-rescue_SHIP_title" }